import { image } from '@nextui-org/theme';
import Pumps_img from '../../../Assets/image/home_page_slider_WEBp/1 controller Slide 1925 x 507.webp';
import Embeded_img from '../../../Assets/image/home_page_slider_WEBp/emded dev.webp';
import Ai_iot_img from '../../../Assets/image/home_page_slider_WEBp/itot.webp'; 
import elctroniecs_img from '../../../Assets/image/home_page_slider_WEBp/final elctroniecs slider.webp';
import { title } from 'framer-motion/client';

const animatedata = [
    {
        // title: "SEA SOLAR PUMP 1",
        // description: "This is the description for the first solar pump.",
        image:Pumps_img
    },
     {
        // title: "EMBEDDED DEVELOPMENT",
        // description: " involves programming microcontrollers and embedded systems to perform dedicated functions within hardware devices.",
        image:Ai_iot_img
    },
    {
        // title: "EMBEDDED DEVELOPMENT",
        // description: " involves programming microcontrollers and embedded systems to perform dedicated functions within hardware devices.",
        image:Embeded_img
    },
    {
        // title: "EMBEDDED DEVELOPMENT",
        // description: " involves programming microcontrollers and embedded systems to perform dedicated functions within hardware devices.",
        image:elctroniecs_img
    },
];

export default animatedata;
